
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3ikmX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0482168600f4d5f4cf15d9cfc991833e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2662da77ba0c2b06$var$_react = $2662da77ba0c2b06$var$_interopRequireDefault((parcelRequire("42omo")));

var $2662da77ba0c2b06$var$_baseNew = $2662da77ba0c2b06$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2662da77ba0c2b06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/flag-filled
 * Usage guidance:
 * Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2662da77ba0c2b06$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $2662da77ba0c2b06$var$_react.default.createElement($2662da77ba0c2b06$var$_baseNew.default, Object.assign({
        name: "FlagFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 1.75A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2z" clip-rule="evenodd"/>`
    }, props));
$2662da77ba0c2b06$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $2662da77ba0c2b06$var$_default = module.exports.default = $2662da77ba0c2b06$var$FlagFilledIcon;

});


//# sourceMappingURL=flag-filled.80b1588d.js.map
